const mapStateToProps = (state) => {
    const {
        api:{
            documentData,
            deletingDocument,
            changingStatusDocument,
        }={},
        directory:{
          shorts,
        }={},

        service:{
            Api:{
                deleteDocument,
                changeStatusDocument,
                actions:{
                    setDocumentData,
                }={},
            }={},

        }={}
    } = state;
    return {
        documentData,
        deletingDocument,
        changingStatusDocument,
        shorts,

        deleteDocument,
        changeStatusDocument,
        setDocumentData,
    }
}

export default mapStateToProps;